var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.message_bar.message_bar_content.is_link_out === true
    ? _c("span", { staticClass: "nt2" }, [
        _vm.isTicketsPage
          ? _c(
              "a",
              {
                staticClass:
                  "f6 f5-ns tc pb0 mb1 lh-solid is-tablet-bold is-beige right-arrow-hover",
                attrs: {
                  href: _vm.message_bar.tickets_message_bar_content.link,
                  target: "_blank",
                },
              },
              [
                _vm._v(
                  "\n    " +
                    _vm._s(_vm.message_bar.tickets_message_bar_content.text) +
                    "  "
                ),
                _c("span", { staticStyle: { "font-weight": "800" } }, [
                  _vm._v(
                    _vm._s(
                      _vm.message_bar.tickets_message_bar_content.link_copy
                    )
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "span",
                  { staticClass: "dib w2" },
                  [
                    _c("simple-svg", {
                      staticClass: "right-arrow is-cream pt2",
                      attrs: { filepath: "/uploads/checkout-arrow.svg" },
                    }),
                  ],
                  1
                ),
              ]
            )
          : _c(
              "a",
              {
                staticClass:
                  "f6 f5-ns tc pb0 mb1 lh-solid is-tablet-bold is-beige right-arrow-hover",
                attrs: {
                  href: _vm.message_bar.message_bar_content.link,
                  target: "_blank",
                },
              },
              [
                _vm._v(
                  "\n    " +
                    _vm._s(_vm.message_bar.message_bar_content.text) +
                    "  "
                ),
                _c("span", { staticStyle: { "font-weight": "800" } }, [
                  _vm._v(_vm._s(_vm.message_bar.message_bar_content.link_copy)),
                ]),
                _vm._v(" "),
                _c(
                  "span",
                  { staticClass: "dib w2" },
                  [
                    _c("simple-svg", {
                      staticClass: "right-arrow is-cream pt2",
                      attrs: { filepath: "/uploads/checkout-arrow.svg" },
                    }),
                  ],
                  1
                ),
              ]
            ),
      ])
    : _vm.message_bar.tickets_message_bar_content.is_link_out === true &&
      _vm.isTicketsPage
    ? _c("span", { staticClass: "nt2" }, [
        _c(
          "a",
          {
            staticClass:
              "f6 f5-ns tc pb0 mb1 lh-solid is-tablet-bold is-beige right-arrow-hover",
            attrs: {
              href: _vm.message_bar.tickets_message_bar_content.link,
              target: "_blank",
            },
          },
          [
            _vm._v(
              "\n    " +
                _vm._s(_vm.message_bar.tickets_message_bar_content.text) +
                "  "
            ),
            _c("span", { staticStyle: { "font-weight": "800" } }, [
              _vm._v(
                _vm._s(_vm.message_bar.tickets_message_bar_content.link_copy)
              ),
            ]),
            _vm._v(" "),
            _c(
              "span",
              { staticClass: "dib w2" },
              [
                _c("simple-svg", {
                  staticClass: "right-arrow is-cream pt2",
                  attrs: { filepath: "/uploads/checkout-arrow.svg" },
                }),
              ],
              1
            ),
          ]
        ),
      ])
    : _c(
        "span",
        { staticClass: "nt2" },
        [
          _vm.isTicketsPage
            ? _c(
                "router-link",
                {
                  staticClass:
                    "f6 f5-ns tc pb0 mb1 lh-solid is-tablet-bold is-beige right-arrow-hover",
                  attrs: {
                    to: _vm.message_bar.tickets_message_bar_content.link,
                  },
                },
                [
                  _vm._v(
                    "\n    " +
                      _vm._s(_vm.message_bar.tickets_message_bar_content.text) +
                      "  "
                  ),
                  _c("span", { staticStyle: { "font-weight": "800" } }, [
                    _vm._v(
                      _vm._s(
                        _vm.message_bar.tickets_message_bar_content.link_copy
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "span",
                    { staticClass: "dib w2" },
                    [
                      _c("simple-svg", {
                        staticClass: "right-arrow is-cream pt2",
                        attrs: { filepath: "/uploads/checkout-arrow.svg" },
                      }),
                    ],
                    1
                  ),
                ]
              )
            : _c(
                "router-link",
                {
                  staticClass:
                    "f6 f5-ns tc pb0 mb1 lh-solid is-tablet-bold is-beige right-arrow-hover",
                  attrs: { to: _vm.message_bar.message_bar_content.link },
                },
                [
                  _vm._v(
                    "\n    " +
                      _vm._s(_vm.message_bar.message_bar_content.text) +
                      "  "
                  ),
                  _c("span", { staticStyle: { "font-weight": "800" } }, [
                    _vm._v(
                      _vm._s(_vm.message_bar.message_bar_content.link_copy)
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "span",
                    { staticClass: "dib w2" },
                    [
                      _c("simple-svg", {
                        staticClass: "right-arrow is-cream pt2",
                        attrs: { filepath: "/uploads/checkout-arrow.svg" },
                      }),
                    ],
                    1
                  ),
                ]
              ),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }